module.exports = __webpack_public_path__ + "img/hatchery.51da3515.svg";